import $ from 'jquery';

/**
 * @typedef StateFilterState
 * @property {string} id
 * @property {string} countryId
 * @property {string} description
 * @property {string} shortDescription
 */

/**
 * @typedef StateFilterCountry
 * @property {string} id
 * @property {string} description
 * @property {string} shortDescription
 * @property {boolean} hasStates
 * @property {boolean} isStateRequired
 * @property {boolean} isCityRequired
 * @property {boolean} isPostalCodeRequired
 * @property {string} isoCode
 */

/**
 * @typedef StateFilterConfig
 * @property {(HTMLInputElement|string)} city
 * @property {(HTMLSelectElement|string)} state
 * @property {(HTMLSelectElement|string)} country
 * @property {(HTMLInputElement|string)} postalCode
 * @property {StateFilterState[]} states
 * @property {StateFilterCountry[]} countries
 */


function getControlGroupElements(groupName) {
  const $group = $(`div[data-control-group-for='${groupName}']`);

  let $requiredMessage = $group.find('.tn-required-field');

  if (!$requiredMessage.length) {
    $requiredMessage = $('<small aria-hidden="true" class="tn-required-field pull-right">Required</small>');
  }

  return {
    $group,
    $requiredMessage,
    $input: $group.find('input, select'),
    $label: $group.find('label'),
  };
}


class StateFilter {
  /** @param {StateFilterConfig} config */
  constructor(config) {
    this.states = config.states;
    this.countries = config.countries;

    this.$countrySelect = $(config.country);
    this.$stateSelect = $(config.state);

    const stateElementName = this.$stateSelect.attr('name');
    const postalCodeElementName = $(config.postalCode).attr('name');
    const cityElementName = $(config.city).attr('name');

    this.controlGroups = {
      state: getControlGroupElements(stateElementName),
      postalCode: getControlGroupElements(postalCodeElementName),
      city: getControlGroupElements(cityElementName),
    };

    const defaultCountryId = this.$countrySelect.val();
    const country = this.getCountry(defaultCountryId);
    const defaultStateId = this.$stateSelect.val();

    this.updateStateListDisplay(country);

    this.toggleControlGroupRequired(country.isCityRequired, this.controlGroups.city);

    this.toggleControlGroupRequired(country.isPostalCodeRequired, this.controlGroups.postalCode);

    this.loadStateListData(country);

    this.setStateDefault(defaultStateId);

    this.$countrySelect.on('change', this.countryChanged.bind(this));
  }

  getCountry(countryId) {
    const value = this.countries.find(country => country.id.toString() === countryId);

    if (value) {
      return value;
    }

    return {
      hasStates: false,
      isCityRequired: false,
      isPostalCodeRequired: false,
      isStateRequired: false,
    };
  }

  clearStateList() {
    this.$stateSelect[0].options.length = 0;
  }

  revalidateStateField() {
    this.$stateSelect.trigger('blur');
  }

  populateStateList(countryId) {
    const dest = this.$stateSelect[0];

    dest.options.length = 0;

    dest.options.add(new Option('Select', ''));

    this.states.forEach((currentValue) => {
      if (currentValue.countryId === countryId) {
        dest.options.add(new Option(currentValue.description, currentValue.shortDescription));
      }
    });
  }

  hideStateList() {
    this.controlGroups.state.$group.hide();
  }

  showStateList() {
    this.controlGroups.state.$group.show();
  }

  setStateDefault(stateId) {
    this.$stateSelect.val(stateId);
  }

  toggleControlGroupRequired(isRequired, { $input, $label, $requiredMessage }) {
    $requiredMessage.remove();

    if (isRequired) {
      $requiredMessage.insertAfter($label[0]);
      $input.attr('data-tn-required', 'true');
    } else {
      $input.removeAttr('data-tn-required');
    }
  }

  updateStateListDisplay(country) {
    if (country.hasStates) {
      this.showStateList();
    } else {
      this.hideStateList();
    }

    this.toggleControlGroupRequired(country.isStateRequired, this.controlGroups.state);
  }

  loadStateListData(country) {
    if (country.hasStates) {
      this.populateStateList(country.id);
    } else {
      this.clearStateList();
    }
  }

  countryChanged() {
    const countryId = this.$countrySelect.val();

    if (countryId > 0) {
      const country = this.getCountry(countryId);

      this.loadStateListData(country);

      this.updateStateListDisplay(country);

      this.toggleControlGroupRequired(country.isCityRequired, this.controlGroups.city);

      this.toggleControlGroupRequired(country.isPostalCodeRequired, this.controlGroups.postalCode);
    }
  }
}

export default StateFilter;



// WEBPACK FOOTER //
// ./src/tnew/lib/StateFilter.js